import type { Services } from '@wix/app-market-services';
import type { Subcategory } from '../categories-tags';

export type getSubCategoriesResponse = {
  subCategories: Subcategory[];
};
export async function getSubCategories({
  services,
  appId,
  languageCode,
}: {
  appId: string;
  services: Services;
  languageCode: string;
}): Promise<getSubCategoriesResponse> {
  const tagsResponse = await services.queryTagApp({ appIds: [appId] });
  const subcategories = await services.queryTag({
    tagIds: tagsResponse.tagIds,
    tagType: 'SUBCATEGORY',
    isHidden: false,
    languageCode,
  });
  const subcategoriesIds = subcategories.ids;
  const uniqueCategoriesIds = Array.from(new Set(subcategories.parentIds));
  const categories = await services.queryTag({
    tagIds: uniqueCategoriesIds,
    tagType: 'CATEGORY',
    isHidden: false,
    languageCode,
  });

  return {
    subCategories: subcategoriesIds.map((subcategoryId) => {
      const subcategory = subcategories.findByTagId(subcategoryId);
      const category = categories.findByTagId(subcategory.parentId);
      return {
        id: subcategoryId,
        slug: subcategory.slug,
        name: subcategory.name,
        parentSlug: category.slug,
        parentName: category.name,
      };
    }),
  };
}
